import { createEmptyAction, createMapAction, immediateAction } from "chalet-shared";

import { RoomView } from "../reducers/rooms";
import { Data } from "../service/Data";

export const actionCreators = {
    onRosterSearchResults: createMapAction(
        "ON_ROSTER_SEARCH_RESULTS",
        (result: Data.RoomsIn) => result
    ),
    rosterSearchOn: createEmptyAction("ROSTER_SEARCH_ON"),
    rosterSearchOff: createEmptyAction("ROSTER_SEARCH_OFF"),
    onRosterSearchLoading: createMapAction("ON_ROSTER_SEARCH_LOADING", (x: RoomView) => x),
    onRosterSearchLoaded: createMapAction("ON_ROSTER_SEARCH_LOADED", (x: RoomView) => x),
    onMentionsOrderUpdate: createMapAction(
        "ON_MENTIONS_ORDER_UPDATE",
        (x: { roomView: RoomView; data: Data.RoomsIn }) => x
    ),
    updateTopSearchInput: immediateAction(
        "UPDATE_ROSTER_ROOM_SEARCH_INPUT",
        (roomType: "forum" | "direct" | "contact" | undefined, value: string) => ({
            type: "UPDATE_ROSTER_ROOM_SEARCH_INPUT",
            roomType,
            value,
            renderImmediate: true,
        })
    ),
};
